// extracted by mini-css-extract-plugin
export default {"cls1":"RIJYgQWw2YBvKqB6sYXu","cls2":"ekrB4XwPiaSt_85bpLO9 RIJYgQWw2YBvKqB6sYXu"};